var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    color: "#8E8E8E",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6036 6.16269V7.44047C16.0389 7.88848 17.0846 9.1878 17.0846 10.7397V14.8538C17.0846 16.775 15.4918 18.3327 13.5282 18.3327H6.4753C4.51077 18.3327 2.91797 16.775 2.91797 14.8538V10.7397C2.91797 9.1878 3.96459 7.88848 5.39904 7.44047V6.16269C5.40751 3.67834 7.46519 1.66602 9.9886 1.66602C12.5459 1.66602 14.6036 3.67834 14.6036 6.16269ZM10.0055 3.11522C11.7245 3.11522 13.1217 4.48161 13.1217 6.16269V7.26077H6.88091V6.14612C6.88938 4.47333 8.28657 3.11522 10.0055 3.11522ZM10.7422 13.7118C10.7422 14.1176 10.412 14.4405 9.99707 14.4405C9.59061 14.4405 9.26037 14.1176 9.26037 13.7118V11.8734C9.26037 11.4759 9.59061 11.1529 9.99707 11.1529C10.412 11.1529 10.7422 11.4759 10.7422 11.8734V13.7118Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIc);
export default __webpack_public_path__ + "static/media/lock_ic.68e6dd3ab640a288b5364946f5bd02d6.svg";
export { ForwardRef as ReactComponent };